export default [
  'emailsignature',
  'vcitapay',
  'appadvancecampaigneditor',
  'yextApp',
  'Quickbooks',
  'tsireports',
  'anapp12',
  'appfacebook',
  'appquickbooks',
  'appfullcontact',
  'yextAppInt',
  'thryvpaybeta_556',
  'signaturesprod',
  'ThryvPay',
  'socialOverviewLabs',
  'signaturesemp',
  'emailsignatureqa',
  'businesswebsiteeditor_775',
  'seolistings_776',
  'businesswebsiteeditor_763',
  'seolistings_764',
  'submitasupportrequest',
  'openidapptest',
  'businesswebsiteeditoro',
  'dudatest',
  'mywikipages',
  'mastercarddemo',
  'roojoom',
  'analyticstest',
  'demoteamchat',
  'clientsimportplayground',
  'telcodemo',
  'qrcode',
  'teamchat_554',
  'instagram_818',
  'mySubscriptionsSandBox',
  'testPremissions',
  'uberall',
  'siteemono',
  'monowebbuilder',
  'webexDemoEnvApp',
  'demoteamchat_601',
  'gmailaddonintegration',
  'cashflowqa',
  'cashflowscalestage_869',
  'cashflowscalestage',
  'cashflowscaledev_824',
  'cashflowforgestage_813',
  'authnz360dev',
  'nucleus',
  'smenucleus_646',
  'yextDemoApp',
  'thryvyextapp',
];
